import { render, staticRenderFns } from "./PlanUpgradeChip.vue?vue&type=template&id=a3e89968&"
import script from "./PlanUpgradeChip.vue?vue&type=script&lang=js&"
export * from "./PlanUpgradeChip.vue?vue&type=script&lang=js&"
import style0 from "./PlanUpgradeChip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports